const basePath = "infrastructure-environmental-systems/";

export const powerSystems = {
  id: 9,
  category: "Power & UPS Systems",

  filters: {
    Brand: { type: "checkbox" },
    Model: { type: "checkbox" },
    Capacity: { type: "checkbox" },
    Type: { type: "checkbox" },
    Features: { type: "checkbox" },
    Range: { type: "checkbox" },
    Ratings: { type: "checkbox" },
    Ports: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "APC Smart-UPS 3000VA",
      bestSeller: true,
      image: `${basePath}APC_Smart-UPS_3000VA.png`,
      details: {
        Brand: "APC",
        Model: "Smart-UPS 3000VA",
        Capacity: "2700W / 3000VA",
      },
      about: `
        <ul>
          <li>Line-interactive UPS with LCD display.</li>
          <li>Provides battery backup and surge protection for critical loads.</li>
        </ul>
      `,
    },
    {
      name: "Eaton 9E Online UPS 6kVA",
      bestSeller: true,
      image: `${basePath}Eaton_9E_Online_UPS_6kVA.svg`,
      details: {
        Brand: "Eaton",
        Model: "9E 6kVA",
        Capacity: "6000VA / 5400W",
        Type: "Online Double Conversion",
      },
      about: `
        <ul>
          <li>High-performance UPS with continuous power conditioning.</li>
          <li>LCD user interface and extended battery options.</li>
        </ul>
      `,
    },
    {
      name: "Riello UPS 10-40kVA",
      bestSeller: false,
      image: `${basePath}Riello_UPS_10-40kVA.png`,
      details: {
        Brand: "Riello",
        Model: "UPS 10-40kVA",
        Type: "Online Double-Conversion",
        Features: "3-phase, redundancy options",
      },
      about: `
        <ul>
          <li>Enterprise-grade online UPS for data centers and critical facilities.</li>
          <li>High efficiency, N+1 redundancy capable.</li>
        </ul>
      `,
    },
    {
      name: "Vertiv Liebert GXe 10-40kVA",
      bestSeller: false,
      image: `${basePath}Vertiv_Liebert_GXe_10-40kVA.png`,
      details: {
        Brand: "Vertiv",
        Model: "Liebert GXe",
        Capacity: "10-40 kVA options",
        Type: "Online UPS with Paralleling",
      },
      about: `
        <ul>
          <li>High-efficiency online UPS designed for enterprise data centers.</li>
          <li>Supports modular scalability and N+X redundancy.</li>
        </ul>
      `,
    },
    {
      name: "VRLA Battery Banks (12V/48V)",
      bestSeller: true,
      image: `${basePath}VRLA_Battery_Banks_(12V_48V).png`,
      details: {
        Brand: "Exell/Enersys",
        Type: "VRLA (Valve-Regulated Lead-Acid)",
        Capacity: "12V/24V/48V options",
        Features: "Sealed, maintenance-free",
      },
      about: `
        <ul>
          <li>Sealed lead-acid batteries ideal for UPS backup systems.</li>
          <li>Maintenance-free with predictable lifespan (5-10 years).</li>
        </ul>
      `,
    },
    {
      name: "Lithium-Ion Battery Systems (Li-Ion)",
      bestSeller: false,
      image: `${basePath}Lithium-Ion_Battery_Systems_(Li-Ion).png`,
      details: {
        Brand: "Fluence/Tesla Megapack",
        Type: "Li-Ion Energy Storage",
        Capacity: "Modular 10-100 kWh",
        Features: "High cycle count, compact design",
      },
      about: `
        <ul>
          <li>Modern Li-Ion battery systems for extended runtime and high cycle counts.</li>
          <li>Compact footprint with integrated BMS (Battery Management System).</li>
        </ul>
      `,
    },
    {
      name: "Diesel Generators 50-500kVA",
      bestSeller: true,
      image: `${basePath}Diesel_Generators_50-500kVA.png`,
      details: {
        Brand: "Caterpillar/Cummins/Generac",
        Type: "Diesel Generator Set",
        Range: "50-500 kVA",
        Features: "Automatic transfer, load sharing",
      },
      about: `
        <ul>
          <li>Industrial-grade diesel generators for long-term backup power.</li>
          <li>Available with ATS and remote monitoring capabilities.</li>
        </ul>
      `,
    },
    {
      name: "Automatic Transfer Switch (ATS)",
      bestSeller: true,
      image: `${basePath}Automatic_Transfer_Switch_(ATS).png`,
      details: {
        Brand: "Eaton/Schneider Electric",
        Type: "Static/Electromechanical ATS",
        Ratings: "16-3200A available",
        Features: "Mains/Generator sensing",
      },
      about: `
        <ul>
          <li>Automatic switches between utility power and generator backup.</li>
          <li>Available in static (no break) and electromechanical options.</li>
        </ul>
      `,
    },
    {
      name: "Power Distribution Units (PDU)",
      bestSeller: true,
      image: `${basePath}Power_Distribution_Units_(PDU).png`,
      details: {
        Brand: "Schneider/APC/Vertiv",
        Type: "Rack PDU / Cabinet PDU",
        Capacity: "Single/Three-phase 16-63A",
        Features: "Monitored, metered, switched options",
      },
      about: `
        <ul>
          <li>Horizontal and vertical mounting PDUs for efficient power distribution in racks.</li>
          <li>Intelligent PDUs offer real-time metering and remote outlet control.</li>
        </ul>
      `,
    },
    {
      name: "Intelligent Rack PDUs (Smart/Metered)",
      bestSeller: true,
      image: `${basePath}Intelligent_Rack_PDUs_(Smart_Metered).png`,
      details: {
        Brand: "APC/Eaton/Geist",
        Type: "Monitored/Metered Rack PDU",
        Ports: "8-42 outlets per PDU",
        Features: "SNMP/HTTP monitoring, power limiting",
      },
      about: `
        <ul>
          <li>Advanced PDUs with outlet-level metering and switching capabilities.</li>
          <li>Enable per-device power budgeting and remote reboot functionality.</li>
        </ul>
      `,
    },
    {
      name: "Static Transfer Switch (STS)",
      bestSeller: false,
      image: `${basePath}Static_Transfer_Switch_(STS).png`,
      details: {
        Brand: "Eaton/Mitsubishi Electric",
        Type: "Static Transfer Switch",
        Ratings: "20-1200A, 3-phase",
        Features: "Zero-break switchover <4ms",
      },
      about: `
        <ul>
          <li>Zero-break static switches for transfer between UPS and primary power sources.</li>
          <li>Maintains critical applications during power source transitions.</li>
        </ul>
      `,
    },
    {
      name: "Busbar Power Systems",
      bestSeller: false,
      image: `${basePath}Busbar_Power_Systems.svg`,
      details: {
        Brand: "Schneider/Eaton",
        Type: "Modular Busbar",
        Capacity: "Up to 5000A",
        Features: "Scalable, low-loss distribution",
      },
      about: `
        <ul>
          <li>Modular busbar systems for high-current power distribution in data centers.</li>
          <li>Lower resistance and heat loss compared to traditional cable distribution.</li>
        </ul>
      `,
    },
  ],
};
